import PropTypes from 'prop-types';
import Nav from 'components/lists/nav';
import NavItem from 'components/lists/nav-item';
import { useFeatureFlag } from 'entities/helpers/use-feature-flag';

/**
 * Tab group for Outreach pages.
 * Note: Bulk Emails tab removed per PM feedback - not in scope.
 */
const OutreachTabGroup = ({ activeTab = 'email', onTabChange = () => {} }) => {
  const { flagEnabled: signalEnabled } = useFeatureFlag('signal');
  const { flagEnabled: cadenceV2Enabled } = useFeatureFlag('cadenceV2Internal');
  const hasCadenceV2 = signalEnabled && cadenceV2Enabled;

  return (
    <Nav active={activeTab} className="outreach--tab-group" onSelect={onTabChange}>
      <NavItem activeWhen="email" label={hasCadenceV2 ? 'YOUR 1:1 EMAILS' : 'Your Emails'} />
      <NavItem activeWhen="phone" label={hasCadenceV2 ? 'YOUR PHONE CALLS' : 'Your Phone Calls'} />
    </Nav>
  );
};

OutreachTabGroup.propTypes = {
  activeTab: PropTypes.string,
  onTabChange: PropTypes.func,
};

export default OutreachTabGroup;
